import React from 'react'
import agent from '../agent'
import MasterAccountList from './widgets/MasterAccountList';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import {
    MASTER_ACCOUNT_LIST_PAGE_LOADED,
    MASTER_ACCOUNT_LIST_PAGE_UNLOADED,
} from '../constants/actionTypes'

const mapStateToProps = state => ({
    ...state.account,
    appName: state.common.appName,
    token: state.common.token,
    date_from: state.common.date_from,
    date_to: state.common.date_to
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) => {
        dispatch({ type: MASTER_ACCOUNT_LIST_PAGE_LOADED, payload })
    },
    onUnload: () =>
        dispatch({ type: MASTER_ACCOUNT_LIST_PAGE_UNLOADED }),
});

class MasterAccounts extends React.Component {
    constructor() {
        super();
    }
    componentWillMount() {
        const payload = agent.Accounts.getMasterAccounts()
        this.props.onLoad(payload);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }
    render() {
        return (
            <div class='pane'>
                {/*<Link className="buttonTop" to='/masteraccounts/create'><i className="icon ion-android-add-circle"></i></Link>*/}
                <h1>Master Accounts</h1>
                <MasterAccountList accounts={this.props.accounts} loading={this.props.loading} />
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MasterAccounts);



// WEBPACK FOOTER //
// ./src/components/MasterAccounts.js